export const charts = {
  Value: { value: 'Value', label: 'Valor', id: 'Value' },
  Pie: { value: 'Pie', label: 'Pizza', id: 'Pie' },
  Line: { value: 'Line', label: 'Linhas', id: 'Line' },
  Bar: { value: 'Bar', label: 'Barras', id: 'Bar' },
  Radar: { value: 'Radar', label: 'Radar', id: 'Radar' },
  Map: { value: 'Map', label: 'Mapa', id: 'Map' },
  Funnel: { value: 'Funnel', label: 'Funil', id: 'Funnel' },
  RadialBar: { value: 'RadialBar', label: 'Barras radiais', id: 'RadialBar' },
  Calendar: { value: 'Calendar', label: 'Calendário', id: 'Calendar' },
  Waffle: { value: 'Waffle', label: 'Waffle', id: 'Waffle' },
  BoxPlot: { value: 'BoxPlot', label: 'Diagrama de Caixa', id: 'BoxPlot' },
  Table: { value: 'Table', label: 'Tabela', id: 'Table' },
  Iframe: { value: 'Iframe', label: 'Customizado', id: 'Iframe' },
  SubsetTable: { value: 'SubsetTable', label: 'Tabela Subconjunto', id: 'SubsetTable' },
  label: { value: 'label', label: 'Insight', id: 'label' },
  ScatterPlot: { value: 'ScatterPlot', label: 'Diagrama de Dispersão', id: 'ScatterPlot' },
  Histogram: { value: 'Histogram', label: 'Histograma', id: 'Histogram' },
  Pareto: { value: 'Pareto', label: 'Pareto', id: 'Pareto' },
  Bullet: { value: 'Bullet', label: 'Marcador', id: 'Bullet' },
  Gauge: { value: 'Gauge', label: 'Velocímetro', id: 'Gauge' },
};

export const roleOpt = [
  { label: 'Proprietário', value: 'super', id: 'super' },
  { label: 'Cientista', value: 'scientist', id: 'scientist' },
  { label: 'Convidado', value: 'guest', id: 'guest' },
];

export const operationalStatusOpt = [
  { label: 'Em implantação', value: 'Em implantação', id: 'Em implantação' },
  { label: 'Em espera', value: 'Em espera', id: 'Em espera' },
  { label: 'Suspenso', value: 'Suspenso', id: 'Suspenso' },
  { label: 'Operacional', value: 'Operacional', id: 'Opercional' },
  { label: 'Cancelado', value: 'Cancelado', id: 'Cancelado' },
  { label: 'Comercial', value: 'Comercial', id: 'Comercial' },
  { label: 'Prospecto', value: 'Prospecto', id: 'Prospecto' },
  { label: 'Preparado', value: 'Preparado', id: 'Preparado' },
  { label: 'Teste', value: 'Teste', id: 'Teste' },
  { label: 'Atenção', value: 'Atenção', id: 'Atenção' },
];

export const frequencyAntecipeiOpt = [
  { label: 'Diária', value: 'Diária', id: 'Diária' },
  { label: 'Dia sim dia não', value: 'Dia sim dia não', id: 'Dia sim dia não' },
  { label: 'Semanal', value: 'Semanal', id: 'Semanal' },
  { label: 'Quinzenal', value: 'Quinzenal', id: 'Quinzenal' },
  { label: 'Mensal', value: 'Mensal', id: 'Mensal' },
];

export const courtsAntecipeiOpt = [
  { label: 'Todos', value: 'Todos', id: 'Todos' },
  { label: 'Trabalhista', value: 'Trabalhista', id: 'Trabalhista' },
  { label: 'Estaduais', value: 'Estaduais', id: 'Estaduais' },
  { label: 'Federais', value: 'Federais', id: 'Federais' },
  { label: 'Customizado', value: 'Customizado', id: 'Customizado' },
];

export const weekDayAntecipeiOpt = [
  { label: 'Segunda-feira', value: 'Segunda-feira', id: 'Segunda-feira' },
  { label: 'Terça-feira', value: 'Terça-feira', id: 'Terça-feira' },
  { label: 'Quarta-feira', value: 'Quarta-feira', id: 'Quarta-feira' },
  { label: 'Quinta-feira', value: 'Quinta-feira', id: 'Quinta-feira' },
  { label: 'Sexta-feira', value: 'Sexta-feira', id: 'Sexta-feira' },
];

export const diskOpt = [
  { label: '500MB', value: '500', id: '500' },
  { label: '1GB', value: '1000', id: '1000' },
  { label: '2GB', value: '2000', id: '2000' },
  { label: '5GB', value: '5000', id: '5000' },
  { label: '10GB', value: '10000', id: '10000' },
  { label: '20GB', value: '20000', id: '20000' },
  { label: '50GB', value: '50000', id: '50000' },
];

export const dashboardOpt = [
  { label: '5', value: 5, id: '5' },
  { label: '10', value: 10, id: '10' },
  { label: '25', value: 25, id: '25' },
  { label: '50', value: 50, id: '50' },
  { label: '100', value: 100, id: '100' },
  { label: '250', value: 250, id: '250' },
  { label: '500', value: 500, id: '500' },
  { label: '1000', value: 1000, id: '1000' },
  { label: '2000', value: 2000, id: '2000' },
  { label: '5000', value: 5000, id: '5000' },
  { label: 'ilimitado', value: 100000, id: 'ilimitado' },
];

export const templatesOpt = [
  { label: 'Nível 1', value: 'level1', id: 'level1' },
  { label: 'Nível 2', value: 'level2', id: 'level2' },
  { label: 'Nível 3', value: 'level3', id: 'level3' },
  { label: 'Nível 4', value: 'level4', id: 'level4' },
];

export const scientistOpt = [
  { label: '1', value: '1', id: '1' },
  { label: '2', value: '2', id: '2' },
  { label: '5', value: '5', id: '5' },
  { label: '10', value: '10', id: '10' },
  { label: '15', value: '15', id: '15' },
  { label: '20', value: '20', id: '20' },
];

export const superOpt = [
  { label: '1', value: '1', id: '1' },
  { label: '2', value: '2', id: '2' },
  { label: '5', value: '5', id: '5' },
  { label: '10', value: '10', id: '10' },
  { label: '15', value: '15', id: '15' },
  { label: '20', value: '20', id: '20' },
];

export const guestOpt = [
  { label: '10', value: '10', id: '10' },
  { label: '20', value: '20', id: '20' },
  { label: '50', value: '50', id: '50' },
  { label: '100', value: '100', id: '100' },
  { label: '200', value: '200', id: '200' },
  { label: '500', value: '500', id: '500' },
  { label: '1000', value: '1000', id: '1000' },
  { label: '2000', value: '2000', id: '2000' },
  { label: '5000', value: '5000', id: '5000' },
  { label: '10000', value: '10000', id: '10000' },
];

export const snapshotOpt = [
  { label: '1', value: '1', id: '1' },
  { label: '3', value: '3', id: '3' },
  { label: '6', value: '6', id: '6' },
  { label: '12', value: '12', id: '12' },
];

export const supportOpt = [
  { label: 'Sem suporte', value: 'noSupport', id: 'noSupport' },
  { label: 'Suporte por e-mail', value: 'emailSupport', id: 'emailSupport' },
  { label: 'Suporte por whatsapp', value: 'whatsSupport', id: 'whatsSupport' },
  { label: 'Suporte por conferência', value: 'confSupport', id: 'confSupport' },
];
export const monthNames = ['01', '02', '03', '04', '05', '06',
  '07', '08', '09', '10', '11', '12'];

export const fillerMap = {
  M: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
  Q: ['T1', 'T2', 'T3', 'T4'],
  month: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
  quarter: ['1º Trim.', '2º Trim.', '3º Trim.', '4º Trim.'],
  semester: ['S1', 'S2'],
  y_semester: ['1º Sem.', '2º Sem.'],
  dayofweek: ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado', 'Domingo'],
  year: [],
  W: [],
};

export const dateOptions = [
  { label: 'Ano (#)', value: 'year', id: 'year' },
  { label: 'Ano-Mês-Dia (A-M-D)', value: 'D', id: 'D' },
  { label: 'Ano-Mês-Dia Hora (A-M-D H:M)', value: 'min', id: 'min' },
  { label: 'Ano-Mês-Dia Hora (A-M-D H:M:S)', value: 's', id: 's' },
  { label: 'Mês-Ano (M-A)', value: 'M', id: 'M' },
  { label: 'Semana (A-M-D/A-M-D)', value: 'W', id: 'W' },
  { label: 'Trimestre (A-T#)', value: 'Q', id: 'Q' },
  { label: 'Trimestre Inglês (A-Q#)', value: 'Q:EN', id: 'Q:EN' },
  { label: 'Semestre (A-S#)', value: 'semester', id: 'semester' },
  { label: 'Mês do Ano [Jan-Dez]', value: 'month', id: 'month' },
  { label: 'Mês do Ano Inglês [Jan-Dec]', value: 'month:EN', id: 'month:EN' },
  { label: 'Trim. do Ano [1ºTrim-4ºTrim]', value: 'quarter', id: 'quarter' },
  { label: 'Trim. do Ano Inglês [1stQtr-4thQtr]', value: 'quarter:EN', id: 'quarter:EN' },
  { label: 'Sem. do Ano [1ºSem-2ºSem]', value: 'y_semester', id: 'y_semester' },
  { label: 'Sem. do Ano Inglês [1stSem-2ndSem]', value: 'y_semester:EN', id: 'y_semester:EN' },
  { label: 'Dia da Semana', value: 'dayofweek', id: 'dayofweek' },
  { label: 'Dia da Semana Inglês', value: 'dayofweek:EN', id: 'dayofweek:EN' },
  { label: 'Dia do Mês [1-31]', value: 'day', id: 'day' },
  { label: 'Semana do Ano [1-53]', value: 'week', id: 'week' },
  { label: 'Dia do Ano [1-366]', value: 'dayofyear', id: 'dayofyear' },
];

export const dateFormatOptions = [
  { label: 'Dia/Mês/Ano (dd/mm/aaaa ou dd-mm-aaaa)', value: 'D-M-A', id: 'D-M-A' },
  { label: 'Mês/Dia/Ano (mm/dd/aaaa ou mm-dd-aaaa)', value: 'M-D-A', id: 'M-D-A' },
  { label: 'Ano/Mês/Dia (aaaa/mm/dd ou aaaa-mm-dd)', value: 'A-M-D', id: 'A-M-D' },
  { label: 'Ano/Dia/Mês (aaaa/dd/mm ou aaaa-dd-mm)', value: 'A-D-M', id: 'A-D-M' },
  { label: 'Mês/Ano/Dia (mm/aaaa/dd ou mm-aaaa-dd)', value: 'M-A-D', id: 'M-A-D' },
  { label: 'Dia/Ano/Mês (dd/aaaa/mm ou dd-aaaa-mm)', value: 'D-A-M', id: 'D-A-M' },
];

export const xlsxDateFormatOptions = [
  { label: 'Ano/Mês/Dia (aaaa/mm/dd ou aaaa-mm-dd)', value: 'A-M-D', id: 'A-M-D' },
];

export const csvDateFormatOptions = [
  { label: 'Dia/Mês/Ano (dd/mm/aaaa ou dd-mm-aaaa)', value: 'D-M-A', id: 'D-M-A' },
  { label: 'Ano/Mês/Dia (aaaa/mm/dd ou aaaa-mm-dd)', value: 'A-M-D', id: 'A-M-D' },
];

export const decimalOptions = [
  { value: '.', label: 'Ponto (.)', id: 'ponto' },
  { value: ',', label: 'Vírgula (,)', id: 'virgula' },
];

export const erpOptions = [
  { value: 'none', label: 'Nenhum', id: 'none' },
  { value: 'Advbox', label: 'Advbox', id: 'Advbox' },
  { value: 'Ajur', label: 'Ajur', id: 'Ajur' },
  { value: 'Astrea', label: 'Astrea', id: 'Astrea' },
  { value: 'Auxilium', label: 'Auxilium', id: 'Auxilium' },
  { value: 'Benner', label: 'Benner', id: 'Benner' },
  { value: 'Brainlaw', label: 'Brainlaw', id: 'Brainlaw' },
  { value: 'CPJ-3C', label: 'CPJ-3C', id: 'CPJ-3C' },
  { value: 'CP-Pro', label: 'CP-Pro', id: 'CP-Pro' },
  { value: 'Datajuri', label: 'Datajuri', id: 'Datajuri' },
  { value: 'DataLawyer', label: 'DataLawyer', id: 'DataLawyer' },
  { value: 'DataVenia', label: 'DataVenia', id: 'DataVenia' },
  { value: 'Digesto', label: 'Digesto', id: 'Digesto' },
  { value: 'Easyjur', label: 'Easyjur', id: 'Easyjur' },
  { value: 'Ebt-Juris', label: 'Ebt-Juris', id: 'Ebt-Juris' },
  { value: 'E-Law', label: 'E-Law', id: 'E-Law' },
  { value: 'Espaider', label: 'Espaider', id: 'Espaider' },
  { value: 'Eterno Jurídico', label: 'Eterno Jurídico', id: 'Eterno Jurídico' },
  { value: 'e-Xyon', label: 'e-Xyon', id: 'e-Xyon' },
  { value: 'FAZ', label: 'FAZ', id: 'FAZ' },
  { value: 'Forelegal', label: 'Forelegal', id: 'Forelegal' },
  { value: 'Gepro', label: 'Gepro', id: 'Gepro' },
  { value: 'Gojur', label: 'Gojur', id: 'Gojur' },
  { value: 'Harpa', label: 'Harpa', id: 'Harpa' },
  { value: 'Integra', label: 'Integra', id: 'Integra' },
  { value: 'Kurier Analytics', label: 'Kurier Analytics', id: 'Kurier Analytics' },
  { value: 'Kurier Meridio', label: 'Kurier Meridio', id: 'Kurier Meridio' },
  { value: 'Lawsoft', label: 'Lawsoft', id: 'Lawsoft' },
  { value: 'Lawyer Eleven', label: 'Lawyer Eleven', id: 'Lawyer Eleven' },
  { value: 'Legal Control', label: 'Legal Control', id: 'Legal Control' },
  { value: 'Legal Manager', label: 'Legal Manager', id: 'Legal Manager' },
  { value: 'Legal One', label: 'Legal One', id: 'Legal One' },
  { value: 'Legitmvs', label: 'Legitmvs', id: 'Legitmvs' },
  { value: 'Lysis', label: 'Lysis', id: 'Lysis' },
  { value: 'MaisJurídico', label: 'MaisJurídico', id: 'MaisJurídico' },
  { value: 'Prawo', label: 'Prawo', id: 'Prawo' },
  { value: 'Projud', label: 'Projud', id: 'Projud' },
  { value: 'Projuris', label: 'Projuris', id: 'Projuris' },
  { value: 'Promad', label: 'Promad', id: 'Promad' },
  { value: 'SAJ-Adv', label: 'SAJ-Adv', id: 'SAJ-Adv' },
  { value: 'Tecnojuris', label: 'Tecnojuris', id: 'Tecnojuris' },
  { value: 'Tedesco', label: 'Tedesco', id: 'Tedesco' },
  { value: 'Themis', label: 'Themis', id: 'Themis' },
  { value: 'Totvs Legal Desk', label: 'Totvs Legal Desk', id: 'Totvs Legal Desk' },
  { value: 'Totvs Sisjuri', label: 'Totvs Sisjuri', id: 'Totvs Sisjuri' },
  { value: 'other', label: 'Outro', id: 'other' },
];

export const fontOptions = [
  {
    value: 'arial', label: 'Arimo', id: 'arial', font: 'arial',
  },
  {
    value: 'bookman', label: 'Libre Baskerville', id: 'bookman', font: 'bookman',
  },
  {
    value: 'courier', label: 'Courier Prime', id: 'Courier', font: 'courier',
  },
  {
    value: 'cursive', label: 'Kalam', id: 'cursive', font: 'cursive',
  },
  {
    value: 'fantasy', label: 'Oswald', id: 'fantasy', font: 'fantasy',
  },
  {
    value: 'helvetica', label: 'Lato', id: 'helvetica', font: 'helvetica',
  },
  {
    value: 'lucida console', label: 'Old Standard TT', id: 'lucida console', font: 'lucida console',
  },
  {
    value: 'monospace', label: 'Fira Mono', id: 'monospace', font: 'monospace',
  },
  {
    value: 'open sans', label: 'Open Sans', id: 'open sans', font: 'open sans',
  },
  {
    value: 'roboto', label: 'Roboto', id: 'roboto', font: 'roboto',
  },
  {
    value: 'rubik', label: 'Rubik', id: 'rubik', font: 'rubik',
  },
  {
    value: 'sans-serif', label: 'Nunito Sans', id: 'sans-serif', font: 'sans-serif',
  },
  {
    value: 'serif', label: 'Playfair Display', id: 'Serif', font: 'serif',
  },
  {
    value: 'tahoma', label: 'Signika', id: 'tahoma', font: 'tahoma',
  },
  {
    value: 'times new roman', label: 'Tinos', id: 'times new roman', font: 'times new roman',
  },
  {
    value: 'verdana', label: 'Jost', id: 'verdana', font: 'verdana',
  },
];

export const filterTypeOptionsSimple = [
  {
    value: 'values', label: 'Valores selecionados', id: 'values', description: 'Valores selecionados',
  },
  {
    value: 'not-values', label: 'Valores não selecionados', id: 'not-values', description: 'Valores não selecionados',
  },
];

const formatDate = (date) => date.toLocaleDateString('pt-BR');

export const getDynamicDateRange = (format, N) => {
  const today = new Date();
  const inverse = format.startsWith('not');
  let startDate;
  let endDate;
  let secondStartDate;
  const secondEndDate = new Date(9999, 11, 31);
  let startQuarter;
  let startSemester;
  let startWeek;

  switch (format) {
    case 'previousY':
    case 'previousyear':
      startDate = new Date(today.getFullYear() - N, 0, 1);
      endDate = new Date(today.getFullYear() - 1, 11, 31);
      break;

    case 'not-previousY':
    case 'not-previousyear':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today.getFullYear() - N - 1, 11, 31);
      secondStartDate = new Date(today.getFullYear(), 0, 1);
      break;

    case 'previousM':
      startDate = new Date(today.getFullYear(), today.getMonth() - N, 1);
      endDate = new Date(today.getFullYear(), today.getMonth(), 0);
      break;

    case 'not-previousM':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today.getFullYear(), today.getMonth() - N, 0);
      secondStartDate = new Date(today.getFullYear(), today.getMonth(), 1);
      break;

    case 'previousD':
      startDate = new Date(today);
      startDate.setDate(today.getDate() - N);
      endDate = new Date(today);
      endDate.setDate(today.getDate() - 1);
      break;

    case 'not-previousD':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today);
      endDate.setDate(today.getDate() - N - 1);
      secondStartDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      break;

    case 'previousQ':
      startQuarter = today.getMonth() - (today.getMonth() % 3) - 3 * N;
      startDate = new Date(today.getFullYear(), startQuarter, 1);
      endDate = new Date(today.getFullYear(), today.getMonth() - (today.getMonth() % 3), 0);
      break;

    case 'not-previousQ':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today.getFullYear(), today.getMonth() - (today.getMonth() % 3) - 3 * N, 0);
      secondStartDate = new Date(today.getFullYear(), today.getMonth() - (today.getMonth() % 3), 1);
      break;

    case 'previousS':
      startSemester = today.getMonth() < 6 ? 0 : 6;
      startDate = new Date(today.getFullYear(), startSemester - 6 * N, 1);
      endDate = new Date(today.getFullYear(), startSemester, 0);
      break;

    case 'not-previousS':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today.getFullYear(), today.getMonth() < 6 ? -6 * N : 6 - 6 * N, 0);
      secondStartDate = new Date(today.getFullYear(), today.getMonth() < 6 ? 0 : 6, 1);
      break;

    case 'previousW':
      startDate = new Date(today);
      startDate.setDate(today.getDate() - today.getDay() - 7 * N);
      endDate = new Date(today);
      endDate.setDate(today.getDate() - today.getDay() - 1);
      break;

    case 'not-previousW':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today);
      endDate.setDate(today.getDate() - today.getDay() - 7 * N - 1);
      secondStartDate = new Date(today);
      secondStartDate.setDate(today.getDate() - today.getDay());
      break;

    case 'current_and_previousY':
    case 'current_and_previousyear':
      startDate = new Date(today.getFullYear() - N, 0, 1);
      endDate = new Date(today.getFullYear(), 11, 31);
      break;

    case 'not-current_and_previousY':
    case 'not-current_and_previousyear':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today.getFullYear() - N - 1, 11, 31);
      secondStartDate = new Date(today.getFullYear() + 1, 0, 1);
      break;

    case 'current_and_previousM':
      startDate = new Date(today.getFullYear(), today.getMonth() - N, 1);
      endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      break;

    case 'not-current_and_previousM':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today.getFullYear(), today.getMonth() - N, 0);
      secondStartDate = new Date(today.getFullYear(), today.getMonth() + 1, 1);
      break;

    case 'current_and_previousD':
      startDate = new Date(today);
      startDate.setDate(today.getDate() - N);
      endDate = today;
      break;

    case 'not-current_and_previousD':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today);
      endDate.setDate(today.getDate() - N - 1);
      secondStartDate = new Date(today);
      secondStartDate.setDate(today.getDate() + 1);
      break;

    case 'current_and_previousQ':
      startQuarter = today.getMonth() - (today.getMonth() % 3) - 3 * N;
      startDate = new Date(today.getFullYear(), startQuarter, 1);
      endDate = new Date(today.getFullYear(), today.getMonth() + 3 - (today.getMonth() % 3), 0);
      break;

    case 'not-current_and_previousQ':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today.getFullYear(), today.getMonth() - (today.getMonth() % 3) - 3 * N, 0);
      secondStartDate = new Date(today.getFullYear(), today.getMonth() + 3 - (today.getMonth() % 3), 1);
      break;

    case 'current_and_previousS':
      startSemester = today.getMonth() < 6 ? 0 : 6;
      startDate = new Date(today.getFullYear(), startSemester - 6 * N, 1);
      endDate = new Date(today.getFullYear(), startSemester + 6, 0);
      break;

    case 'not-current_and_previousS':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today.getFullYear(), today.getMonth() < 6 ? -6 * N : 6 - 6 * N, 0);
      secondStartDate = new Date(today.getFullYear(), today.getMonth() < 6 ? 6 : 12, 1);
      break;

    case 'current_and_previousW':
      startWeek = new Date(today);
      startWeek.setDate(today.getDate() - today.getDay());
      startDate = new Date(startWeek);
      startDate.setDate(startWeek.getDate() - N * 7);
      endDate = new Date(startWeek);
      endDate.setDate(startWeek.getDate() + 6);
      break;

    case 'not-current_and_previousW':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today);
      endDate.setDate(today.getDate() - today.getDay() - 7 * N - 1);
      secondStartDate = new Date(today);
      secondStartDate.setDate(today.getDate() + (7 - today.getDay()));
      break;

    case 'followingY':
    case 'followingyear':
      startDate = new Date(today.getFullYear() + 1, 0, 1);
      endDate = new Date(today.getFullYear() + N + 1, 0, 0);
      break;

    case 'not-followingY':
    case 'not-followingyear':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today.getFullYear(), 11, 31);
      secondStartDate = new Date(today.getFullYear() + N + 1, 0, 1);
      break;

    case 'followingM':
      startDate = new Date(today.getFullYear(), today.getMonth() + 1, 1);
      endDate = new Date(today.getFullYear(), today.getMonth() + N + 1, 0);
      break;

    case 'not-followingM':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      secondStartDate = new Date(today.getFullYear(), today.getMonth() + N + 1, 1);
      break;

    case 'followingD':
      startDate = new Date(today);
      startDate.setDate(today.getDate() + 1);
      endDate = new Date(today);
      endDate.setDate(today.getDate() + N);
      break;

    case 'not-followingD':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today);
      secondStartDate = new Date(today);
      secondStartDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + N + 1);
      break;

    case 'followingQ':
      startDate = new Date(today.getFullYear(), today.getMonth() - (today.getMonth() % 3) + 3, 1);
      endDate = new Date(
        today.getFullYear(),
        today.getMonth() - (today.getMonth() % 3) + 3 * (N + 1),
        0,
      );
      break;

    case 'not-followingQ':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today.getFullYear(), today.getMonth() - (today.getMonth() % 3) + 3, 0);
      secondStartDate = new Date(
        today.getFullYear(),
        today.getMonth() - (today.getMonth() % 3) + 3 * (N + 1),
        1,
      );
      break;

    case 'followingS':
      startDate = new Date(today.getFullYear(), today.getMonth() < 6 ? 6 : 12, 1);
      endDate = new Date(today.getFullYear(), today.getMonth() < 6 ? 6 + 6 * N : 12 + 6 * N, 0);
      break;

    case 'not-followingS':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today.getFullYear(), today.getMonth() < 6 ? 6 : 12, 0);
      secondStartDate = new Date(
        today.getFullYear(),
        today.getMonth() < 6 ? 6 + 6 * N : 12 + 6 * N,
        1,
      );
      break;

    case 'followingW':
      startDate = new Date(today);
      startDate.setDate(today.getDate() + 7 - today.getDay());
      endDate = new Date(today);
      endDate.setDate(today.getDate() + 7 * (N + 1) - today.getDay() - 1);
      break;

    case 'not-followingW':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today);
      endDate.setDate(today.getDate() + 7 - today.getDay() - 1);
      secondStartDate = new Date(today);
      secondStartDate.setDate(today.getDate() + 7 * (N + 1) - today.getDay());
      break;

    case 'current_and_followingY':
    case 'current_and_followingyear':
      startDate = new Date(today.getFullYear(), 0, 1);
      endDate = new Date(today.getFullYear() + N + 1, 0, 0);
      break;

    case 'not-current_and_followingY':
    case 'not-current_and_followingyear':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today.getFullYear(), 0, 0);
      secondStartDate = new Date(today.getFullYear() + N + 1, 0, 1);
      break;

    case 'current_and_followingM':
      startDate = new Date(today.getFullYear(), today.getMonth(), 1);
      endDate = new Date(today.getFullYear(), today.getMonth() + N + 1, 0);
      break;

    case 'not-current_and_followingM':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today.getFullYear(), today.getMonth(), 0);
      secondStartDate = new Date(today.getFullYear(), today.getMonth() + N + 1, 1);
      break;

    case 'current_and_followingD':
      startDate = new Date(today);
      startDate.setDate(today.getDate());
      endDate = new Date(today);
      endDate.setDate(today.getDate() + N);
      break;

    case 'not-current_and_followingD':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today);
      endDate.setDate(today.getDate() - 1);
      secondStartDate = new Date(today);
      secondStartDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + N + 1);
      break;

    case 'current_and_followingQ':
      startDate = new Date(today.getFullYear(), today.getMonth() - today.getMonth() % 3, 1);
      endDate = new Date(
        today.getFullYear(),
        today.getMonth() - (today.getMonth() % 3) + 3 * (N + 1),
        0,
      );
      break;

    case 'not-current_and_followingQ':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today.getFullYear(), today.getMonth() - today.getMonth() % 3, 0);
      secondStartDate = new Date(
        today.getFullYear(),
        today.getMonth() - (today.getMonth() % 3) + 3 * (N + 1),
        1,
      );
      break;

    case 'current_and_followingS':
      startDate = new Date(today.getFullYear(), today.getMonth() < 6 ? 0 : 6, 1);
      endDate = new Date(today.getFullYear(), today.getMonth() < 6 ? 6 + 6 * N : 12 + 6 * N, 0);
      break;

    case 'not-current_and_followingS':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today.getFullYear(), today.getMonth() < 6 ? 0 : 6, 0);
      secondStartDate = new Date(
        today.getFullYear(),
        today.getMonth() < 6 ? 6 + 6 * N : 12 + 6 * N,
        1,
      );
      break;

    case 'current_and_followingW':
      startDate = new Date(today);
      startDate.setDate(today.getDate() - today.getDay());
      endDate = new Date(today);
      endDate.setDate(today.getDate() + 7 * (N + 1) - today.getDay() - 1);
      break;

    case 'not-current_and_followingW':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today);
      endDate.setDate(today.getDate() - today.getDay() - 1);
      secondStartDate = new Date(today);
      secondStartDate.setDate(today.getDate() + 7 * (N + 1) - today.getDay());
      break;

    case 'lastY':
    case 'lastyear':
      startDate = new Date(today.getFullYear() - N + 1, 0, 1);
      endDate = new Date(today);
      endDate.setDate(today.getDate() - 1);
      break;

    case 'not-lastY':
    case 'not-lastyear':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today.getFullYear() - N + 1, 0, 0);
      secondStartDate = today;
      break;

    case 'lastM':
      startDate = new Date(today.getFullYear(), today.getMonth() - N + 1, 1);
      endDate = new Date(today);
      endDate.setDate(today.getDate() - 1);
      break;

    case 'not-lastM':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today.getFullYear(), today.getMonth() - N + 1, 0);
      secondStartDate = today;
      break;

    case 'lastD':
      startDate = new Date(today);
      startDate.setDate(today.getDate() - N);
      endDate = new Date(today);
      endDate.setDate(today.getDate() - 1);
      break;

    case 'not-lastD':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today);
      endDate.setDate(today.getDate() - N - 1);
      secondStartDate = today;
      break;

    case 'lastQ':
      startQuarter = today.getMonth() - (today.getMonth() % 3) - 3 * (N - 1);
      startDate = new Date(today.getFullYear(), startQuarter, 1);
      endDate = new Date(today);
      endDate.setDate(today.getDate() - 1);
      break;

    case 'not-lastQ':
      startDate = new Date(0, 0, 1);
      endDate = new Date(
        today.getFullYear(),
        today.getMonth() - (today.getMonth() % 3) - 3 * (N - 1),
        0,
      );
      secondStartDate = today;
      break;

    case 'lastS':
      startSemester = today.getMonth() < 6 ? 0 : 6;
      startDate = new Date(today.getFullYear(), startSemester - 6 * (N - 1), 1);
      endDate = new Date(today);
      endDate.setDate(today.getDate() - 1);
      break;

    case 'not-lastS':
      startDate = new Date(0, 0, 1);
      endDate = new Date(
        today.getFullYear(),
        today.getMonth() < 6 ? -6 * (N - 1) : 6 - 6 * (N - 1),
        0,
      );
      secondStartDate = today;
      break;

    case 'lastW':
      startDate = new Date(today);
      startDate.setDate(today.getDate() - today.getDay() - 7 * (N - 1));
      endDate = new Date(today);
      endDate.setDate(today.getDate() - 1);
      break;

    case 'not-lastW':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today);
      endDate.setDate(today.getDate() - today.getDay() - 7 * (N - 1) - 1);
      secondStartDate = today;
      break;

    case 'nextY':
    case 'nextyear':
      startDate = today;
      endDate = new Date(today.getFullYear() + N, 0, 0);
      break;

    case 'not-nextY':
    case 'not-nextyear':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today);
      endDate.setDate(today.getDate() - 1);
      secondStartDate = new Date(today.getFullYear() + N, 0, 1);
      break;

    case 'nextM':
      startDate = today;
      endDate = new Date(today.getFullYear(), today.getMonth() + N, 0);
      break;

    case 'not-nextM':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today);
      endDate.setDate(endDate.getDate() - 1);
      secondStartDate = new Date(today.getFullYear(), today.getMonth() + N, 1);
      break;

    case 'nextD':
      startDate = today;
      endDate = new Date(today);
      endDate.setDate(today.getDate() + N - 1);
      break;

    case 'not-nextD':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today);
      endDate.setDate(endDate.getDate() - 1);
      secondStartDate = new Date(today);
      secondStartDate.setDate(secondStartDate.getDate() + N);
      break;

    case 'nextQ':
      startDate = today;
      endDate = new Date(
        today.getFullYear(),
        today.getMonth() + (today.getMonth() % 3) + 3 * N,
        0,
      );
      break;

    case 'not-nextQ':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today);
      endDate.setDate(endDate.getDate() - 1);
      secondStartDate = new Date(
        today.getFullYear(),
        today.getMonth() + (today.getMonth() % 3) + 3 * N,
        1,
      );
      break;

    case 'nextS':
      startDate = today;
      endDate = new Date(
        today.getFullYear(),
        today.getMonth() < 6 ? 6 + 6 * (N - 1) : 12 + 6 * (N - 1),
        0,
      );
      break;

    case 'not-nextS':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today);
      endDate.setDate(endDate.getDate() - 1);
      secondStartDate = new Date(
        today.getFullYear(),
        today.getMonth() < 6 ? 6 + 6 * (N - 1) : 12 + 6 * (N - 1),
        1,
      );
      break;

    case 'nextW':
      startDate = today;
      endDate = new Date(today);
      endDate.setDate(today.getDate() + 7 * N - today.getDay() - 1);
      break;

    case 'not-nextW':
      startDate = new Date(0, 0, 1);
      endDate = new Date(today);
      endDate.setDate(endDate.getDate() - 1);
      secondStartDate = new Date(today);
      secondStartDate.setDate(today.getDate() + 7 * N - today.getDay());
      break;

    default:
      return 'Filtro não reconhecido';
  }

  const result = {
    today: formatDate(today),
    inverse,
    firstInterval: {
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
    },
  };

  if (inverse) {
    result.secondInterval = {
      startDate: formatDate(secondStartDate),
      endDate: formatDate(secondEndDate),
    };
  }

  return result;
};

export const filterTypeOptionsDate = [
  // { value: 'values', label: 'Por valores', id: 'values' },
  {
    value: 'specific_date',
    label: 'Momento específico',
    id: 'specific_date',
    description: 'Retorna a data selecionada entre ontem, hoje ou amanhã.',
  },
  // n anteriores
  {
    value: 'previousY',
    label: 'N anos anteriores',
    id: 'previousY',
    description: `Retorna todas as datas dentro dos N anos anteriores completos,
      não considerando o ano atual. Exemplo: se N = 2, as datas selecionadas
      estarão entre as datas ${getDynamicDateRange('previousY', 2).firstInterval.startDate} e
      ${getDynamicDateRange('previousY', 2).firstInterval.endDate}.
      `,
  },
  {
    value: 'not-previousY',
    label: 'Inverso dos N anos anteriores',
    id: 'not-previousY',
    description: `Retorna todas as datas antes e depois dos N anos anteriores
    completos. Exemplo: se N = 2, o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-previousY', 2).firstInterval.endDate} e maiores
    ou iguais a ${getDynamicDateRange('not-previousY', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'previousM',
    label: 'N meses anteriores',
    id: 'previousM',
    description: `Retorna todas as datas dentro dos últimos N meses completos,
      não considerando o mês atual. Exemplo: se N = 2, as datas selecionadas
      estarão entre as datas ${getDynamicDateRange('previousM', 2).firstInterval.startDate} e
      ${getDynamicDateRange('previousM', 2).firstInterval.endDate}.
      `,
  },
  {
    value: 'not-previousM',
    label: 'Inverso dos N meses anteriores',
    id: 'not-previousM',
    description: `Retorna todas as datas antes e depois dos N meses anteriores
    completos. Exemplo: se N = 2, o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-previousM', 2).firstInterval.endDate} e maiores
    ou iguais a ${getDynamicDateRange('not-previousM', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'previousD',
    label: 'N dias anteriores',
    id: 'previousD',
    description: `Retorna todas as datas dos N dias anteriores completos, não considerando
    o dia atual. Exemplo: se N = 2, as datas selecionadas estarão entre as datas
    ${getDynamicDateRange('previousD', 2).firstInterval.startDate} e
    ${getDynamicDateRange('previousD', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-previousD',
    label: 'Inverso dos N dias anteriores',
    id: 'not-previousD',
    description: `Retorna todas as datas antes e depois dos N dias anteriores completos.
    Exemplo: se N = 2, o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-previousD', 2).firstInterval.endDate} e maiores
    ou iguais a ${getDynamicDateRange('not-previousD', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'previousQ',
    label: 'N trimestres anteriores',
    id: 'previousQ',
    description: `Retorna todas as datas dos N trimestres anteriores completos, não considerando
    o trimestre atual. Exemplo: se N = 2, as datas selecionadas estarão entre as datas
    ${getDynamicDateRange('previousQ', 2).firstInterval.startDate} e
    ${getDynamicDateRange('previousQ', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-previousQ',
    label: 'Inverso dos N trimestres anteriores',
    id: 'not-previousQ',
    description: `Retorna todas as datas antes e depois dos N trimestres anteriores completos.
    Exemplo: se N = 2, o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-previousQ', 2).firstInterval.endDate} e maiores
    ou iguais a ${getDynamicDateRange('not-previousQ', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'previousS',
    label: 'N semestres anteriores',
    id: 'previousS',
    description: `Retorna todas as datas dos N semestres anteriores completos, não considerando
    o semestre atual. Exemplo: se N = 2, as datas selecionadas estarão entre as datas
    ${getDynamicDateRange('previousS', 2).firstInterval.startDate} e
    ${getDynamicDateRange('previousS', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-previousS',
    label: 'Inverso dos N semestres anteriores',
    id: 'not-previousS',
    description: `Retorna todas as datas antes e depois dos N semestres anteriores completos.
    Exemplo: se N = 2, o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-previousS', 2).firstInterval.endDate} e maiores
    ou iguais a ${getDynamicDateRange('not-previousS', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'previousW',
    label: 'N semanas anteriores',
    id: 'previousW',
    description: `Retorna todas as datas das N semanas anteriores completas, não considerando
    a semana atual. Exemplo: se N = 2, as datas selecionadas estarão entre as datas
    ${getDynamicDateRange('previousW', 2).firstInterval.startDate} e
    ${getDynamicDateRange('previousW', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-previousW',
    label: 'Inverso das N semanas anteriores',
    id: 'not-previousW',
    description: `Retorna todas as datas antes e depois das N semanas anteriores completas.
    Exemplo: se N = 2, o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-previousW', 2).firstInterval.endDate} e maiores
    ou iguais a ${getDynamicDateRange('not-previousW', 2).secondInterval.startDate}.
    `,
  },
  // atual e n anteriores
  {
    value: 'current_and_previousY',
    label: 'Ano atual e N anteriores',
    id: 'current_and_previousY',
    description: `Retorna todas as datas do ano atual e dos N anos anteriores. Exemplo: se
    N = 2, as datas selecionadas estarão entre as datas
    ${getDynamicDateRange('current_and_previousY', 2).firstInterval.startDate} e
    ${getDynamicDateRange('current_and_previousY', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-current_and_previousY',
    label: 'Inverso do ano atual e N anteriores',
    id: 'not-current_and_previousY',
    description: `Retorna todas as datas antes dos N anos anteriores e após o ano atual.
    Exemplo: se N = 2, o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-current_and_previousY', 2).firstInterval.endDate} e maiores
    ou iguais a ${getDynamicDateRange('not-current_and_previousY', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'current_and_previousM',
    label: 'Mês atual e N anteriores',
    id: 'current_and_previousM',
    description: `Retorna todas as datas do mês atual e dos N meses anteriores. Exemplo: se
    N = 2, as datas selecionadas estarão entre as datas
    ${getDynamicDateRange('current_and_previousM', 2).firstInterval.startDate} e
    ${getDynamicDateRange('current_and_previousM', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-current_and_previousM',
    label: 'Inverso do mês atual e N anteriores',
    id: 'not-current_and_previousM',
    description: `Retorna todas as datas antes dos N meses anteriores e após o mês atual.
    Exemplo: se N = 2, o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-current_and_previousM', 2).firstInterval.endDate} e maiores
    ou iguais a ${getDynamicDateRange('not-current_and_previousM', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'current_and_previousD',
    label: 'Dia atual e N anteriores',
    id: 'current_and_previousD',
    description: `Retorna todas as datas do dia atual e dos N dias anteriores. Exemplo: se
    N = 2, as datas selecionadas estarão entre as datas
    ${getDynamicDateRange('current_and_previousD', 2).firstInterval.startDate} e
    ${getDynamicDateRange('current_and_previousD', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-current_and_previousD',
    label: 'Inverso do dia atual e N anteriores',
    id: 'not-current_and_previousD',
    description: `Retorna todas as datas antes dos N dias anteriores e após o dia atual.
    Exemplo: se N = 2, o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-current_and_previousD', 2).firstInterval.endDate} e maiores
    ou iguais a ${getDynamicDateRange('not-current_and_previousD', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'current_and_previousQ',
    label: 'Trimestre atual e N anteriores',
    id: 'current_and_previousQ',
    description: `Retorna todas as datas do trimestre atual e dos N trimestres anteriores. Exemplo:
    se N = 2, as datas selecionadas estarão entre as datas
    ${getDynamicDateRange('current_and_previousQ', 2).firstInterval.startDate} e
    ${getDynamicDateRange('current_and_previousQ', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-current_and_previousQ',
    label: 'Inverso do trimestre atual e N anteriores',
    id: 'not-current_and_previousQ',
    description: `Retorna todas as datas antes dos N trimestres anteriores e após o trimestre atual.
    Exemplo: se N = 2, o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-current_and_previousQ', 2).firstInterval.endDate} e maiores
    ou iguais a ${getDynamicDateRange('not-current_and_previousQ', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'current_and_previousS',
    label: 'Semestre atual e N anteriores',
    id: 'current_and_previousS',
    description: `Retorna todas as datas do semestre atual e dos N semestres anteriores. Exemplo: se
    N = 2, as datas selecionadas estarão entre as datas
    ${getDynamicDateRange('current_and_previousS', 2).firstInterval.startDate} e
    ${getDynamicDateRange('current_and_previousS', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-current_and_previousS',
    label: 'Inverso do semestre atual e N anteriores',
    id: 'not-current_and_previousS',
    description: `Retorna todas as datas antes dos N semestres anteriores e após o semestre atual.
    Exemplo: se N = 2, o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-current_and_previousS', 2).firstInterval.endDate} e maiores
    ou iguais a ${getDynamicDateRange('not-current_and_previousS', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'current_and_previousW',
    label: 'Semana atual e N anteriores',
    id: 'current_and_previousW',
    description: `Retorna todas as datas da semana atual e das N semanas anteriores. Exemplo: se
    N = 2, as datas selecionadas estarão entre as datas
    ${getDynamicDateRange('current_and_previousW', 2).firstInterval.startDate} e
    ${getDynamicDateRange('current_and_previousW', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-current_and_previousW',
    label: 'Inverso da semana atual e N anteriores',
    id: 'not-current_and_previousW',
    description: `Retorna todas as datas antes das N semanas anteriores e após a semana atual.
    Exemplo: se N = 2, o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-current_and_previousW', 2).firstInterval.endDate} e maiores
    ou iguais a ${getDynamicDateRange('not-current_and_previousW', 2).secondInterval.startDate}.
    `,
  },
  // n seguintes
  {
    value: 'followingY',
    label: 'N anos seguintes',
    id: 'followingY',
    description: `Retorna todas as datas dos N anos posteriores. Exemplo: se
    N = 2, as datas selecionadas estarão entre as datas
    ${getDynamicDateRange('followingY', 2).firstInterval.startDate} e
    ${getDynamicDateRange('followingY', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-followingY',
    label: 'Inverso dos N anos seguintes',
    id: 'not-followingY',
    description: `Retorna todas as datas antes e depois dos N anos posteriores
    completos. Exemplo: se N = 2, o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-followingY', 2).firstInterval.endDate} e maiores
    ou iguais a ${getDynamicDateRange('not-followingY', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'followingM',
    label: 'N meses seguintes',
    id: 'followingM',
    description: `Retorna todas as datas dos N meses posteriores. Exemplo: se
    N = 2, as datas selecionadas estarão entre as datas
    ${getDynamicDateRange('followingM', 2).firstInterval.startDate} e
    ${getDynamicDateRange('followingM', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-followingM',
    label: 'Inverso dos N meses seguintes',
    id: 'not-followingM',
    description: `Retorna todas as datas antes e depois dos N meses posteriores
    completos. Exemplo: se N = 2, o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-followingM', 2).firstInterval.endDate} e maiores
    ou iguais a ${getDynamicDateRange('not-followingM', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'followingD',
    label: 'N dias seguintes',
    id: 'followingD',
    description: `Retorna todas as datas dos N dias posteriores. Exemplo: se
    N = 2, as datas selecionadas estarão entre as datas
    ${getDynamicDateRange('followingD', 2).firstInterval.startDate} e
    ${getDynamicDateRange('followingD', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-followingD',
    label: 'Inverso dos N dias seguintes',
    id: 'not-followingD',
    description: `Retorna todas as datas antes e depois dos N dias posteriores
    completos. Exemplo: se N = 2, o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-followingD', 2).firstInterval.endDate} e maiores
    ou iguais a ${getDynamicDateRange('not-followingD', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'followingQ',
    label: 'N trimestres seguintes',
    id: 'followingQ',
    description: `Retorna todas as datas dos N trimestres posteriores. Exemplo: se
    N = 2, as datas selecionadas estarão entre as datas
    ${getDynamicDateRange('followingQ', 2).firstInterval.startDate} e
    ${getDynamicDateRange('followingQ', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-followingQ',
    label: 'Inverso dos N trimestres seguintes',
    id: 'not-followingQ',
    description: `Retorna todas as datas antes e depois dos N trimestres posteriores
    completos. Exemplo: se N = 2, o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-followingQ', 2).firstInterval.endDate} e maiores
    ou iguais a ${getDynamicDateRange('not-followingQ', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'followingS',
    label: 'N semestres seguintes',
    id: 'followingS',
    description: `Retorna todas as datas dos N semestres posteriores. Exemplo: se
    N = 2, as datas selecionadas estarão entre as datas
    ${getDynamicDateRange('followingS', 2).firstInterval.startDate} e
    ${getDynamicDateRange('followingS', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-followingS',
    label: 'Inverso dos N semestres seguintes',
    id: 'not-followingS',
    description: `Retorna todas as datas antes e depois dos N semestres posteriores
    completos. Exemplo: se N = 2, o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-followingS', 2).firstInterval.endDate} e maiores
    ou iguais a ${getDynamicDateRange('not-followingS', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'followingW',
    label: 'N semanas seguintes',
    id: 'followingW',
    description: `Retorna todas as datas das N semanas posteriores. Exemplo: se
    N = 2, as datas selecionadas estarão entre as datas
    ${getDynamicDateRange('followingW', 2).firstInterval.startDate} e
    ${getDynamicDateRange('followingW', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-followingW',
    label: 'Inverso das N semanas seguintes',
    id: 'not-followingW',
    description: `Retorna todas as datas antes e depois das N semanas posteriores
    completos. Exemplo: se N = 2, o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-followingW', 2).firstInterval.endDate} e maiores
    ou iguais a ${getDynamicDateRange('not-followingW', 2).secondInterval.startDate}.
    `,
  },
  // atual e próximos n
  {
    value: 'current_and_followingY',
    label: 'Ano atual e N seguintes',
    id: 'current_and_followingY',
    description: `Retorna todas as datas do ano atual e dos N anos posteriores. Exemplo: se
    N = 2, as datas selecionadas estarão entre as datas
    ${getDynamicDateRange('current_and_followingY', 2).firstInterval.startDate} e
    ${getDynamicDateRange('current_and_followingY', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-current_and_followingY',
    label: 'Inverso do ano atual e N seguintes',
    id: 'not-current_and_followingY',
    description: `Retorna todas as datas antes do ano atual e depois dos N anos posteriores.
    Exemplo: se N = 2, o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-current_and_followingY', 2).firstInterval.endDate} e maiores
    ou iguais a ${getDynamicDateRange('not-current_and_followingY', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'current_and_followingM',
    label: 'Mês atual e N seguintes',
    id: 'current_and_followingM',
    description: `Retorna todas as datas do mês atual e dos N meses posteriores. Exemplo: se
    N = 2, as datas selecionadas estarão entre as datas
    ${getDynamicDateRange('current_and_followingM', 2).firstInterval.startDate} e
    ${getDynamicDateRange('current_and_followingM', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-current_and_followingM',
    label: 'Inverso do mês atual e N seguintes',
    id: 'not-current_and_followingM',
    description: `Retorna todas as datas antes do mês atual e depois dos N meses posteriores.
    Exemplo: se N = 2, o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-current_and_followingM', 2).firstInterval.endDate} e maiores
    ou iguais a ${getDynamicDateRange('not-current_and_followingM', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'current_and_followingD',
    label: 'Dia atual e N seguintes',
    id: 'current_and_followingD',
    description: `Retorna todas as datas do dia atual e dos N dias posteriores. Exemplo: se
    N = 2, as datas selecionadas estarão entre as datas
    ${getDynamicDateRange('current_and_followingD', 2).firstInterval.startDate} e
    ${getDynamicDateRange('current_and_followingD', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-current_and_followingD',
    label: 'Inverso do dia atual e N seguintes',
    id: 'not-current_and_followingD',
    description: `Retorna todas as datas antes do dia atual e depois dos N dias posteriores.
    Exemplo: se N = 2, o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-current_and_followingD', 2).firstInterval.endDate} e maiores
    ou iguais a ${getDynamicDateRange('not-current_and_followingD', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'current_and_followingQ',
    label: 'Trimestre atual e N seguintes',
    id: 'current_and_followingQ',
    description: `Retorna todas as datas do trimestre atual e dos N trimestres posteriores. Exemplo: se
    N = 2, as datas selecionadas estarão entre as datas
    ${getDynamicDateRange('current_and_followingQ', 2).firstInterval.startDate} e
    ${getDynamicDateRange('current_and_followingQ', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-current_and_followingQ',
    label: 'Inverso do trimestre atual e N seguintes',
    id: 'not-current_and_followingQ',
    description: `Retorna todas as datas antes do trimestre atual e depois dos N trimestres posteriores.
    Exemplo: se N = 2, o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-current_and_followingQ', 2).firstInterval.endDate} e maiores
    ou iguais a ${getDynamicDateRange('not-current_and_followingQ', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'current_and_followingS',
    label: 'Semestre atual e N seguintes',
    id: 'current_and_followingS',
    description: `Retorna todas as datas do semestre atual e dos N semestres posteriores. Exemplo: se
    N = 2, as datas selecionadas estarão entre as datas
    ${getDynamicDateRange('current_and_followingS', 2).firstInterval.startDate} e
    ${getDynamicDateRange('current_and_followingS', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-current_and_followingS',
    label: 'Inverso do semestre atual e N seguintes',
    id: 'not-current_and_followingS',
    description: `Retorna todas as datas antes do semestre atual e depois dos N semestres posteriores.
    Exemplo: se N = 2, o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-current_and_followingS', 2).firstInterval.endDate} e maiores
    ou iguais a ${getDynamicDateRange('not-current_and_followingS', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'current_and_followingW',
    label: 'Semana atual e N seguintes',
    id: 'current_and_followingW',
    description: `Retorna todas as datas da semana atual e das N semanas posteriores. Exemplo: se
    N = 2, as datas selecionadas estarão entre as datas
    ${getDynamicDateRange('current_and_followingW', 2).firstInterval.startDate} e
    ${getDynamicDateRange('current_and_followingW', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-current_and_followingW',
    label: 'Inverso da semana atual e N seguintes',
    id: 'not-current_and_followingW',
    description: `Retorna todas as datas antes da semana atual e depois das N semanas posteriores.
    Exemplo: se N = 2, o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-current_and_followingW', 2).firstInterval.endDate} e maiores
    ou iguais a ${getDynamicDateRange('not-current_and_followingW', 2).secondInterval.startDate}.
    `,
  },

  {
    value: 'lastY',
    label: 'Últimos N anos até ontem',
    id: 'lastY',
    description: `Retorna todas as datas dos últimos N anos até a data de ontem. O ano atual,
    mesmo incompleto, é incluído na conta. Exemplo: se N = 2, as datas selecionadas estarão
    entre as datas ${getDynamicDateRange('lastY', 2).firstInterval.startDate} e
    ${getDynamicDateRange('lastY', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-lastY',
    label: 'Inverso dos últimos N anos até ontem',
    id: 'not-lastY',
    description: `Retorna todas as datas antes dos últimos N anos e a partir da data de hoje.
    O ano atual, mesmo incompleto, é incluído na conta para o cálculo do inverso. Exemplo: se N = 2,
    o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-lastY', 2).firstInterval.endDate}
    e maiores ou iguais a ${getDynamicDateRange('not-lastY', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'lastM',
    label: 'Últimos N meses até ontem',
    id: 'lastM',
    description: `Retorna todas as datas dos últimos N meses até a data de ontem. O mês atual,
    mesmo incompleto, é incluído na conta. Exemplo: se N = 2, as datas selecionadas estarão entre
    as datas ${getDynamicDateRange('lastM', 2).firstInterval.startDate} e
    ${getDynamicDateRange('lastM', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-lastM',
    label: 'Inverso dos últimos N meses até ontem',
    id: 'not-lastM',
    description: `Retorna todas as datas antes dos últimos N meses e a partir da data de hoje.
    O mês atual, mesmo incompleto, é incluído na conta para o cálculo do inverso. Exemplo: se N = 2,
    o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-lastM', 2).firstInterval.endDate}
    e maiores ou iguais a ${getDynamicDateRange('not-lastM', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'lastD',
    label: 'Últimos N dias até ontem',
    id: 'lastD',
    description: `Retorna todas as datas dos últimos N dias até a data de ontem. Exemplo: se N = 2,
    as datas selecionadas estarão entre as datas
    ${getDynamicDateRange('lastD', 2).firstInterval.startDate} e
    ${getDynamicDateRange('lastD', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-lastD',
    label: 'Inverso dos últimos N dias até ontem',
    id: 'not-lastD',
    description: `Retorna todas as datas antes dos últimos N dias e a partir da data de hoje. Exemplo: se N = 2,
    o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-lastD', 2).firstInterval.endDate}
    e maiores ou iguais a ${getDynamicDateRange('not-lastD', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'lastQ',
    label: 'Últimos N trimestres até ontem',
    id: 'lastQ',
    description: `Retorna todas as datas dos últimos N trimestres até a data de ontem. O trimestre
    atual, mesmo incompleto, é incluído na conta. Exemplo: se N = 2, as datas selecionadas estarão
    entre as datas ${getDynamicDateRange('lastQ', 2).firstInterval.startDate} e
    ${getDynamicDateRange('lastQ', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-lastQ',
    label: 'Inverso dos últimos N trimestres até ontem',
    id: 'not-lastQ',
    description: `Retorna todas as datas antes dos últimos N trimestres e a partir da data de hoje.
    O trimestre atual, mesmo incompleto, é incluído na conta para o cálculo do inverso. Exemplo: se N = 2,
    o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-lastQ', 2).firstInterval.endDate} e maiores ou iguais a
    ${getDynamicDateRange('not-lastQ', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'lastS',
    label: 'Últimos N semestres até ontem',
    id: 'lastS',
    description: `Retorna todas as datas dos últimos N semestres até a data de ontem. O semestre
    atual, mesmo incompleto, é incluído na conta. Exemplo: se N = 2, as datas selecionadas estarão
    entre as datas ${getDynamicDateRange('lastS', 2).firstInterval.startDate} e
    ${getDynamicDateRange('lastS', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-lastS',
    label: 'Inverso dos últimos N semestres até ontem',
    id: 'not-lastS',
    description: `Retorna todas as datas antes dos últimos N semestres e a partir da data de hoje.
    O semestre atual, mesmo incompleto, é incluído na conta para o cálculo do inverso. Exemplo: se N = 2,
    o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-lastS', 2).firstInterval.endDate} e maiores ou iguais a
    ${getDynamicDateRange('not-lastS', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'lastW',
    label: 'Últimas N semanas até ontem',
    id: 'lastW',
    description: `Retorna todas as datas das últimas N semanas até a data de ontem. A semana atual,
    mesmo incompleta, é incluída na conta. Exemplo: se N = 2, as datas selecionadas estarão
    entre as datas ${getDynamicDateRange('lastW', 2).firstInterval.startDate} e
    ${getDynamicDateRange('lastW', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-lastW',
    label: 'Inverso das últimas N semanas',
    id: 'not-lastW',
    description: `Retorna todas as datas antes das últimas N semanas e a partir da data de hoje.
    A semana atual, mesmo incompleta, é incluída na conta para o cálculo do inverso. Exemplo: se N = 2,
    o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-lastW', 2).firstInterval.endDate} e maiores ou iguais a
    ${getDynamicDateRange('not-lastW', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'nextY',
    label: 'Próximos N anos a partir de hoje',
    id: 'nextY',
    description: `Retorna todas as datas dos próximos N anos a partir da data de hoje. O ano atual,
    mesmo incompleto, é incluído na conta. Exemplo: se N = 2, as datas selecionadas estarão entre
    as datas ${getDynamicDateRange('nextY', 2).firstInterval.startDate} e
    ${getDynamicDateRange('nextY', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-nextY',
    label: 'Inverso dos próximos N anos a partir de hoje',
    id: 'not-nextY',
    description: `Retorna todas as datas anteriores ao dia de hoje e a partir dos próximos N anos.
    O ano atual, mesmo incompleto, é incluído na conta para o cálculo do inverso. Exemplo: se N = 2,
    o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-nextY', 2).firstInterval.endDate} e maiores ou iguais a
    ${getDynamicDateRange('not-nextY', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'nextM',
    label: 'Próximos N meses a partir de hoje',
    id: 'nextM',
    description: `Retorna todas as datas dos próximos N meses a partir da data de hoje. O mês atual,
    mesmo incompleto, é incluído na conta. Exemplo: se N = 2, as datas selecionadas estarão entre
    as datas ${getDynamicDateRange('nextM', 2).firstInterval.startDate} e
    ${getDynamicDateRange('nextM', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-nextM',
    label: 'Inverso dos próximos N meses a partir de hoje',
    id: 'not-nextM',
    description: `Retorna todas as datas anteriores ao dia de hoje e a partir dos próximos N meses.
    O mês atual, mesmo incompleto, é incluído na conta para o cálculo do inverso. Exemplo: se N = 2,
    o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-nextM', 2).firstInterval.endDate} e maiores ou iguais a
    ${getDynamicDateRange('not-nextM', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'nextD',
    label: 'Próximos N dias a partir de hoje',
    id: 'nextD',
    description: `Retorna todas as datas dos próximos N dias a partir da data de hoje. Exemplo: se N = 2,
    as datas selecionadas estarão entre as datas ${getDynamicDateRange('nextD', 2).firstInterval.startDate}
    e ${getDynamicDateRange('nextD', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-nextD',
    label: 'Inverso dos próximos N dias a partir de hoje',
    id: 'not-nextD',
    description: `Retorna todas as datas anteriores ao dia de hoje e a partir dos próximos N dias. Exemplo: se N = 2,
    as datas selecionadas estarão entre as datas ${getDynamicDateRange('not-nextD', 2).firstInterval.endDate}
    e ${getDynamicDateRange('not-nextD', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'nextQ',
    label: 'Próximos N trimestres a partir de hoje',
    id: 'nextQ',
    description: `Retorna todas as datas dos próximos N trimestres a partir da data de hoje. O trimestre atual,
    mesmo incompleto, é incluído na conta. Exemplo: se N = 2, as datas selecionadas estarão entre
    as datas ${getDynamicDateRange('nextQ', 2).firstInterval.startDate} e
    ${getDynamicDateRange('nextQ', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-nextQ',
    label: 'Inverso dos próximos N trimestres a partir de hoje',
    id: 'not-nextQ',
    description: `Retorna todas as datas anteriores ao dia de hoje e a partir dos próximos N trimestres.
    O trimestre atual, mesmo incompleto, é incluído na conta para o cálculo do inverso. Exemplo: se N = 2,
    o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-nextQ', 2).firstInterval.endDate} e maiores ou iguais a
    ${getDynamicDateRange('not-nextQ', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'nextS',
    label: 'Próximos N semestres a partir de hoje',
    id: 'nextS',
    description: `Retorna todas as datas dos próximos N semestres a partir da data de hoje. O semestre atual,
    mesmo incompleto, é incluído na conta. Exemplo: se N = 2, as datas selecionadas estarão entre
    as datas ${getDynamicDateRange('nextS', 2).firstInterval.startDate} e
    ${getDynamicDateRange('nextS', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-nextS',
    label: 'Inverso dos próximos N semestres a partir de hoje',
    id: 'not-nextS',
    description: `Retorna todas as datas anteriores ao dia de hoje e a partir dos próximos N semestres.
    O semestre atual, mesmo incompleto, é incluído na conta para o cálculo do inverso. Exemplo: se N = 2,
    o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-nextS', 2).firstInterval.endDate} e maiores ou iguais a
    ${getDynamicDateRange('not-nextS', 2).secondInterval.startDate}.
    `,
  },
  {
    value: 'nextW',
    label: 'Próximas N semanas a partir de hoje',
    id: 'nextW',
    description: `Retorna todas as datas das próximas N semanas a partir da data de hoje. A semana atual
    é incluída na conta. Exemplo: se N = 2, as datas selecionadas estarão entre
    as datas ${getDynamicDateRange('nextW', 2).firstInterval.startDate} e
    ${getDynamicDateRange('nextW', 2).firstInterval.endDate}.
    `,
  },
  {
    value: 'not-nextW',
    label: 'Inverso das próximas N semanas a partir de hoje',
    id: 'not-nextW',
    description: `Retorna todas as datas anteriores ao dia de hoje e a partir das próximas N semanas.
    A semana atual, mesmo incompleta, é incluída na conta para o cálculo do inverso. Exemplo: se N = 2,
    o intervalo será de todas as datas menores ou iguais a
    ${getDynamicDateRange('not-nextW', 2).firstInterval.endDate} e maiores ou iguais a
    ${getDynamicDateRange('not-nextW', 2).secondInterval.startDate}.
    `,
  },
  // entre datas
  {
    value: 'after',
    label: 'A partir da data N (exclusive)',
    id: 'after',
    description: 'Retorna todas as datas a partir da data selecionada, sem incluí-la.',
  },
  // { value: 'not-after', label: '[NOT] A partir da data N (exclusive)', id: 'not-after' },
  {
    value: 'before',
    label: 'Antes da data N (exclusive)',
    id: 'before',
    description: 'Retorna todas as datas anteriores a data selecionada, sem incluí-la.',
  },
  // { value: 'not-before', label: '[NOT] Antes da data N (exclusive)', id: 'not-before' },
  {
    value: 'between',
    label: 'Entre datas A e B (exclusive)',
    id: 'between',
    description: 'Retorna todas as datas entre as datas A e B, sem incluí-las.',
  },
  {
    value: 'not-between_inc',
    label: 'Não está entre as datas A e B (inclusive)',
    id: 'not-between_inc',
    description: 'Retorna todas as datas anteriores a A e posteriores a B, inclindo A e B.',
  },
  {
    value: 'after_inc',
    label: 'A partir da data N (inclusive)',
    id: 'after_inc',
    description: 'Retorna todas as datas a partir da data selecionada, incluindo-a.',
  },
  // { value: 'not-after_inc', label: '[NOT] A partir da data N (inclusive)', id: 'not-after_inc' },
  {
    value: 'before_inc',
    label: 'Antes da data N (inclusive)',
    id: 'before_inc',
    description: 'Retorna todas as datas anteriores a data selecionada, incluindo-a.',
  },
  // { value: 'not-before_inc', label: '[NOT] Antes da data N (inclusive)', id: 'not-before_inc' },
  {
    value: 'between_inc',
    label: 'Entre datas A e B (inclusive)',
    id: 'between_inc',
    description: 'Retorna todas as datas entre as datas A e B, incluindo A e B.',
  },
  {
    value: 'not-between',
    label: 'Não está entre as datas A e B (exclusive)',
    id: 'not-between',
    description: 'Retorna todas as datas anteriores a A e posteriores a B, sem incluir A e B.',
  },
];

export const groupTypeOptionsDate = [
  // { value: 'values', label: 'Por valores', id: 'values' },
  { value: 'last', label: 'Últimas N datas', id: 'last' },
  { value: 'not-last', label: 'Inverso das últimas N datas', id: 'not-last' },
  { value: 'after', label: 'A partir da data N (exclusive)', id: 'after' },
  // { value: 'not-after', label: '[NOT] A partir da data N (exclusive)', id: 'not-after' },
  { value: 'after_inc', label: 'A partir da data N (inclusive)', id: 'after_inc' },
  // { value: 'not-after_inc', label: '[NOT] A partir da data N (inclusive)', id: 'not-after_inc' },
  { value: 'before', label: 'Antes da data N (exclusive)', id: 'before' },
  // { value: 'not-before', label: '[NOT] Antes da data N (exclusive)', id: 'not-before' },
  { value: 'before_inc', label: 'Antes da data N (inclusive)', id: 'before_inc' },
  // { value: 'not-before_inc', label: '[NOT] Antes da data N (inclusive)', id: 'not-before_inc' },
  { value: 'between', label: 'Entre datas A e B (exclusive)', id: 'between' },
  { value: 'not-between_inc', label: 'Não está entre datas A e B (inclusive)', id: 'not-between_inc' },
  { value: 'between_inc', label: 'Entre datas A e B (inclusive)', id: 'between_inc' },
  { value: 'not-between', label: 'Não está entre datas A e B (exclusive)', id: 'not-between_inc' },
];

export const filterTypeOptionsPeriod = [
  // filtros de mês
  {
    value: 'current_month', label: 'Mês atual', id: 'current_month', description: 'Retorna todas as datas do mês atual.',
  },
  // filtros de ano
  {
    value: 'current_year', label: 'Ano atual', id: 'current_year', description: 'Retorna todas as datas do ano atual.',
  },
  // Filtros de semana
  {
    value: 'current_week', label: 'Semana atual', id: 'current_week', description: 'Retorna todas as datas da semana atual de Domingo a sábado.',
  },
  // filtros de trimestre
  {
    value: 'current_quarter', label: 'Trimestre atual', id: 'current_quarter', description: 'Retorna todas as datas do trimestre atual.',
  },
  // Filtros de semestre
  {
    value: 'current_semester', label: 'Semestre atual', id: 'current_semester', description: 'Retorna todas as datas do semestre atual.',
  },
];

export const filterTypeOptionsText = [
  {
    value: 'most',
    label: 'N mais frequentes (sem empate)',
    id: 'most',
    description: 'Retorna os N valores mais frequentes. Em caso de empate na posição N, nenhum dos valores empatados é retornado.',
  },
  {
    value: 'not-most',
    label: 'Não está entre os N mais frequentes (sem empate)',
    id: 'not-most',
    description: 'Retorna todos os valores exceto os N mais frequentes. Em caso de empate na posição N, todos os valores empatados são mantidos no resultado.',
  },
  {
    value: 'most_inc',
    label: 'N mais frequentes (com empate)',
    id: 'most_inc',
    description: 'Retorna os N valores mais frequentes. Em caso de empate na posição N, todos os valores empatados são incluídos no resultado.',
  },
  {
    value: 'not-most_inc',
    label: 'Não está entre os N mais frequentes (com empate)',
    id: 'not-most_inc',
    description: 'Retorna todos os valores exceto os N mais frequentes. Em caso de empate na posição N, todos os valores empatados são excluídos do resultado.',
  },
  {
    value: 'least',
    label: 'N menos frequentes (sem empate)',
    id: 'least',
    description: 'Retorna os N valores menos frequentes. Em caso de empate na posição N, nenhum dos valores empatados é retornado.',
  },
  {
    value: 'not-least',
    label: 'Não está entre os N menos frequentes (sem empate)',
    id: 'not-least',
    description: 'Retorna todos os valores exceto os N menos frequentes. Em caso de empate na posição N, todos os valores empatados são mantidos no resultado.',
  },
  {
    value: 'least_inc',
    label: 'N menos frequentes (com empate)',
    id: 'least_inc',
    description: 'Retorna os N valores menos frequentes. Em caso de empate na posição N, todos os valores empatados são incluídos no resultado.',
  },
  {
    value: 'not-least_inc',
    label: 'Não está entre os N menos frequentes (com empate)',
    id: 'not-least_inc',
    description: 'Retorna todos os valores exceto os N menos frequentes. Em caso de empate na posição N, todos os valores empatados são excluídos do resultado.',
  },
  {
    value: 'contains',
    label: 'Contém o texto',
    id: 'contains',
    description: 'Retorna todos os valores que contêm o texto informado.',
  },
  {
    value: 'not-contains',
    label: 'Não contém o texto',
    id: 'not-contains',
    description: 'Retorna todos os valores que não contêm o texto informado.',
  },
];

export const filterTypeOptionsNumber = [
  {
    value: 'greater',
    label: 'Maiores que N',
    id: 'greater',
    description: 'Retorna todos os valores estritamente maiores que N.',
  },
  {
    value: 'greater_inc',
    label: 'Maiores ou iguais a N',
    id: 'greater_inc',
    description: 'Retorna todos os valores maiores ou iguais a N.',
  },
  {
    value: 'lesser',
    label: 'Menores que N',
    id: 'lesser',
    description: 'Retorna todos os valores estritamente menores que N.',
  },
  {
    value: 'lesser_inc',
    label: 'Menores ou iguais a N',
    id: 'lesser_inc',
    description: 'Retorna todos os valores menores ou iguais a N.',
  },
  {
    value: 'between',
    label: 'Entre A e B (exclusive)',
    id: 'between',
    description: 'Retorna todos os valores maiores que A e menores que B.',
  },
  {
    value: 'not-between_inc',
    label: 'Não está entre A e B (inclusive)',
    id: 'not-between_inc',
    description: 'Retorna todos os valores menores do que A ou maiores que B.',
  },
  {
    value: 'between_inc',
    label: 'Entre A e B (inclusive)',
    id: 'between_inc',
    description: 'Retorna todos os valores maiores ou iguais a A e menores ou iguais a B.',
  },
  {
    value: 'not-between',
    label: 'Não está entre A e B (exclusive)',
    id: 'not-between',
    description: 'Retorna todos os valores menores ou iguais a A ou maiores ou iguais a B.',
  },
];

export const filterTypeOptionsValues = [
  {
    value: 'none',
    label: 'Nenhum',
    id: 'none',
    description: 'Nenhum filtro aplicado, retorna todos os valores.',
  },
  {
    value: 'greater',
    label: 'Maiores que N',
    id: 'greater',
    description: 'Retorna todos os valores estritamente maiores que N.',
  },
  {
    value: 'greater_inc',
    label: 'Maiores ou iguais a N',
    id: 'greater_inc',
    description: 'Retorna todos os valores maiores ou iguais a N.',
  },
  {
    value: 'lesser',
    label: 'Menores que N',
    id: 'lesser',
    description: 'Retorna todos os valores estritamente menores que N.',
  },
  {
    value: 'lesser_inc',
    label: 'Menores ou iguais a N',
    id: 'lesser_inc',
    description: 'Retorna todos os valores menores ou iguais a N.',
  },
  {
    value: 'between',
    label: 'Entre A e B (exclusive)',
    id: 'between',
    description: 'Retorna todos os valores maiores que A e menores que B.',
  },
  {
    value: 'not-between',
    label: 'Não está entre A e B (exclusive)',
    id: 'not-between',
    description: 'Retorna todos os valores menores ou iguais a A ou maiores ou iguais a B.',
  },
  {
    value: 'between_inc',
    label: 'Entre A e B (inclusive)',
    id: 'between_inc',
    description: 'Retorna todos os valores maiores ou iguais a A e menores ou iguais a B.',
  },
  {
    value: 'not-between_inc',
    label: 'Não está entre A e B (inclusive)',
    id: 'not-between_inc',
    description: 'Retorna todos os valores menores que A ou maiores que B.',
  },
  {
    value: 'most',
    label: 'N Maiores (sem empate)',
    id: 'most',
    description: 'Retorna os N maiores valores. Em caso de empate na posição N, nenhum dos valores empatados é retornado.',
  },
  {
    value: 'not-most',
    label: 'Não está entre os N maiores (sem empate)',
    id: 'not-most',
    description: 'Retorna todos os valores exceto os N maiores. Em caso de empate na posição N, todos os valores empatados são mantidos no resultado.',
  },
  {
    value: 'most_inc',
    label: 'N Maiores (com empate)',
    id: 'most_inc',
    description: 'Retorna os N maiores valores. Em caso de empate na posição N, todos os valores empatados são incluídos no resultado.',
  },
  {
    value: 'not-most_inc',
    label: 'Não está entre os N maiores (com empate)',
    id: 'not-most_inc',
    description: 'Retorna todos os valores exceto os N maiores. Em caso de empate na posição N, todos os valores empatados são excluídos do resultado.',
  },
  {
    value: 'least',
    label: 'N Menores (sem empate)',
    id: 'least',
    description: 'Retorna os N menores valores. Em caso de empate na posição N, nenhum dos valores empatados é retornado.',
  },
  {
    value: 'not-least',
    label: 'Não está entre os N menores (sem empate)',
    id: 'not-least',
    description: 'Retorna todos os valores exceto os N menores. Em caso de empate na posição N, todos os valores empatados são mantidos no resultado.',
  },
  {
    value: 'least_inc',
    label: 'N Menores (com empate)',
    id: 'least_inc',
    description: 'Retorna os N menores valores. Em caso de empate na posição N, todos os valores empatados são incluídos no resultado.',
  },
  {
    value: 'not-least_inc',
    label: 'Não está entre os N menores (com empate)',
    id: 'not-least_inc',
    description: 'Retorna todos os valores exceto os N menores. Em caso de empate na posição N, todos os valores empatados são excluídos do resultado.',
  },
];
export const controlVarDescription = `
  Permite criar visualizações diversas para o KPI criado a partir de filtros de valores desta variável.
`;
export const drilldownVarDescription = `
  Permite criar subgráficos com base nos valores desta variável.
`;

export const positionOptions = (isMapOrRadar) => (
  {
    Acima: {
      direction: 'row',
      anchor: 'top',
      translateX: 0,
      translateY: isMapOrRadar ? -50 : -30,
      selectedPosition: 'top',
      label: 'Acima',
    },
    Esquerda: {
      direction: 'column',
      anchor: 'left',
      translateX: -30,
      translateY: 0,
      selectedPosition: 'left',
      label: 'Esquerda',
    },
    Direita: {
      direction: 'column',
      anchor: 'right',
      translateX: isMapOrRadar ? -190 : 110,
      translateY: 0,
      selectedPosition: 'right',
      label: 'Direita',
    },
    Abaixo: {
      direction: 'row',
      anchor: 'bottom',
      translateX: 0,
      translateY: isMapOrRadar ? -100 : 30,
      selectedPosition: 'bot',
      label: 'Abaixo',
    },
  }
);

export const legendPositionOptions = (pos, opts = { isMapOrRadar: false, isWaffle: false }) => {
  switch (pos) {
    case 'Acima': return {
      direction: 'row',
      anchor: 'top',
      translateX: 0,
      translateY: opts.isMapOrRadar ? -50 : -30,
      selectedPosition: 'top',
      label: 'Acima',
    };
    case 'Esquerda': return {
      direction: 'column',
      anchor: 'left',
      translateX: opts.isWaffle ? 40 : -30,
      translateY: 0,
      selectedPosition: 'left',
      label: 'Esquerda',
    };
    case 'Direita': return {
      direction: 'column',
      anchor: 'right',
      // eslint-disable-next-line no-nested-ternary
      translateX: opts.isMapOrRadar ? -190 : (opts.isWaffle ? -150 : 110),
      translateY: 0,
      selectedPosition: 'right',
      label: 'Direita',
    };
    case 'Abaixo': return {
      direction: 'row',
      anchor: 'bottom',
      translateX: 0,
      // eslint-disable-next-line no-nested-ternary
      translateY: opts.isMapOrRadar ? -100 : (opts.isWaffle ? -50 : 30),
      selectedPosition: 'bot',
      label: 'Abaixo',
    };
    default:
      return {};
  }
};

/**
 * Uploader constants start
 */
export const waitMessagesUpload = [
  'Aguarde...',
  'Aguarde..',
  'Aguarde.',
  'Verificando as colunas de texto',
  'Verificando as colunas numéricas',
  'Verificando as colunas de data',
  'Preparando o banco de dados',
  'Realizando alguns tratamentos',
  'Criando os metadados',
  'Ajustando alguns detalhes',
];
export const waitMessagesReUpload = [
  'Aguarde...',
  'Aguarde..',
  'Aguarde.',
  'Verificando a compatibilidade dos dados',
  'Atualizando as informações de metadados',
  'Alterando as informações no banco de dados',
  "Atualizando os KPI's",
  'Modificando os dashboards',
];

export const waitMessagesDonwload = [
  '',
  'O sistema está preparando o seu download.',
  'Isso pode demorar um pouco!',
  'Aguarde...',
  'Aguarde..',
  'Aguarde.',
];

/**
 * Uploader constants end
 */

/**
 * FilesViewer constants start
 */

export const filesViewerWaitMessagesReUpload = [
  'Aguarde...',
  'Aguarde..',
  'Aguarde.',
  'Verificando a compatibilidade dos dados',
  'Atualizando as informações de metadados',
  'Alterando as informações no banco de dados',
  "Atualizando os KPI's",
  'Modificando os dashboards',
];

/**
 * FilesViewer constants end
 */

/**
 * FilesViewer constants start
 */

export const labelCreateInitialState = {
  bold: false,
  underline: false,
  italic: false,
  name: '',
  link: '',
  fontColor: '#111',
  bgColor: '#ddd',
  fontFamily: { value: 'arial', label: 'Arial' },
  fontSize: 16,
  image: '',
  colorOpacityText: '#ddd',
  opacityText: 1,
  opacityImage: 1,
  imageFit: 'contain',
  textPosition: 'center',
  textOrientation: 'horizontal',
  textAlign: 'center',
};

/**
 * FilesViewer constants end
 */

/**
 * Create Instance constants start
 */

export const CreateInstanceFirstLoginMessages = [
  'Aguarde...',
  'Aguarde..',
  'Aguarde.',
  'Aguarde enquanto estamos carregando suas informações',
  'Se este for o seu primeiro acesso, sua instância está sendo criada. Isto pode demorar um pouquinho',
  'Verificando a autenticação do usuário',
  'Verificando informações adicionais de acesso',
  'Aguarde.',
  'Aguarde..',
  'Aguarde...',
];

/**
 * Create Instance constants end
 */

export const MuralLogActions = {
  user_add: 'adicionou o usuário',
  user_edit: 'alterou a permissão do usuário',
  user_remove: 'removeu o usuário',
  user_update: 'atualizou o usuário',
  dashboard_add: 'adicionou o dashboard',
  dashboard_edit: 'alterou o nome do dashboard',
  dashboard_remove: 'removeu o dashboard',
  dashboard_update: 'atualizou o dashboard',
  kpi_add: 'criou o kpi',
  kpi_edit: 'editou o kpi',
  kpi_remove: 'removeu o kpi',
  kpi_update: 'atualizou o kpi',
  story_add: 'criou o story',
  story_edit: 'alterou o nome do story',
  story_remove: 'removeu o story',
  story_update: 'atualizou o story',
  insight_add: 'criou um insight',
  insight_edit: 'editou um insight',
  insight_remove: 'removeu um insight',
  insight_update: 'atualizou um insight',
  get(type, action) {
    return this[`${type}_${action}`] || '';
  },
};

export const shareDashOptions = {
  visualizador: {
    id: 'read-id',
    label: 'Visualização',
    value: 'visualizador',
  },
  edit: {
    id: 'edit-id',
    label: 'Permitir cópia',
    value: 'edit',
  },
  get(k) {
    return this[k].label || 'Visualização';
  },
  getOptions() {
    return [this.visualizador, this.edit];
  },
};

export const shareFileOptions = {
  read: {
    id: 'read-id',
    label: 'Visualização',
    value: 'read',
  },
  write: {
    id: 'write-id',
    label: 'Permitir atualização',
    value: 'write',
  },
  get(k) {
    return this[k].label || 'Visualização';
  },
  getOptions() {
    return [this.read, this.write];
  },
};

export const supportEmail = () => {
  switch (process.env.REACT_APP_FIREBASE_PROJECT_LABEL) {
    case 'legalone-analytics':
      return 'suporte@legalone-analytics.com.br';

    case 'benner-metrics':
      return 'suporte@bennermetrics.com.br';

    default:
      return 'suporte@legalmetrics.com.br';
  }
};

export const ufOptions = [
  { value: 'AC', id: 'AC', label: 'Acre' },
  { value: 'AL', id: 'AL', label: 'Alagoas' },
  { value: 'AP', id: 'AP', label: 'Amapá' },
  { value: 'AM', id: 'AM', label: 'Amazonas' },
  { value: 'BA', id: 'BA', label: 'Bahia' },
  { value: 'CE', id: 'CE', label: 'Ceará' },
  { value: 'DF', id: 'DF', label: 'Distrito Federal' },
  { value: 'ES', id: 'ES', label: 'Espirito Santo' },
  { value: 'GO', id: 'GO', label: 'Goiás' },
  { value: 'MA', id: 'MA', label: 'Maranhão' },
  { value: 'MS', id: 'MS', label: 'Mato Grosso do Sul' },
  { value: 'MT', id: 'MT', label: 'Mato Grosso' },
  { value: 'MG', id: 'MG', label: 'Minas Gerais' },
  { value: 'PA', id: 'PA', label: 'Pará' },
  { value: 'PB', id: 'PB', label: 'Paraíba' },
  { value: 'PR', id: 'PR', label: 'Paraná' },
  { value: 'PE', id: 'PE', label: 'Pernambuco' },
  { value: 'PI', id: 'PI', label: 'Piauí' },
  { value: 'RJ', id: 'RJ', label: 'Rio de Janeiro' },
  { value: 'RN', id: 'RN', label: 'Rio Grande do Norte' },
  { value: 'RS', id: 'RS', label: 'Rio Grande do Sul' },
  { value: 'RO', id: 'RO', label: 'Rondônia' },
  { value: 'RR', id: 'RR', label: 'Roraima' },
  { value: 'SC', id: 'SC', label: 'Santa Catarina' },
  { value: 'SP', id: 'SP', label: 'São Paulo' },
  { value: 'SE', id: 'SE', label: 'Sergipe' },
  { value: 'TO', id: 'TO', label: 'Tocantins' },
];

export const orgaoOptions = [
  { value: '1', label: '1 - Supremo Tribunal Federal', id: 'o-1' },
  { value: '2', label: '2 - Conselho Nacional de Justiça', id: 'o-2' },
  { value: '3', label: '3 - Superior Tribunal de Justiça', id: 'o-3' },
  { value: '4', label: '4 - Justiça Federal', id: 'o-4' },
  { value: '5', label: '5 - Justiça do Trabalho', id: 'o-5' },
  { value: '6', label: '6 - Justiça Eleitoral', id: 'o-6' },
  { value: '7', label: '7 - Justiça Militar da União', id: 'o-7' },
  { value: '8', label: '8 - Justiça dos Estados e do Distrito Federal e Territórios', id: 'o-8' },
  { value: '9', label: '9 - Justiça Militar Estadual', id: 'o-9' },
];

export const poloOptions = [
  { value: 'ativo', label: 'Ativo', id: 'ativo' },
  { value: 'passivo', label: 'Passivo', id: 'passivo' },
  { value: 'terceiros', label: 'Terceiros', id: 'terceiros' },
];
export const defaultDashStyle = {
  // CARD
  backgroundColor: '#ffffff',
  borderColor: '#9a9a9a',
  borderLine: 'solid',
  borderRounded: 4,
  borderSize: 1,
  shading: false,
  spaceBetween: 1,
  // THEME
  useGlobalTheme: false,
  titles: '#000000',
  charts: ['#4711B2', '#FF9626'],
  insightBg: '#FF9626',
  insightTxt: '#FFFFFF',
  valueBg: '#4711B2',
  valueTxt: '#FFFFFF',
  tableRows: ['#FFFFFF', '#FFFFFF'],
  tableHeader: '#555555',
  // FONT
  useGlobalFont: false,
  fontTitle: 'arial',
  fontLabel: 'sans-serif',
  fontAxis: 'arial',
  fontLegend: 'sans-serif',
  fontInsight: 'arial',
  fontValue: 'arial',
  fontTable: 'arial',
};

export const formatStrOpts = [
  { label: 'Nenhum', value: 'NONE', id: 'NONE' },
  { label: 'Compactar', value: 'compact', id: 'compact' },
  { label: 'Maiúsculas', value: 'upper', id: 'upper' },
  { label: 'Minúsculas', value: 'lower', id: 'lower' },
];

export const formatDateOpts = [
  { label: 'Nenhum', value: 'NONE', id: 'NONE' },
  ...dateOptions,
];

export const formatNumOpts = [
  { label: 'Nenhum', value: 'NONE', id: 'NONE' },
  { label: 'Inteiros', value: 'int', id: 'int' },
  { label: 'Moeda R$', value: 'R$', id: 'R$' },
  { label: 'Moeda $', value: '$', id: '$' },
];

export const agentOpts = [
  { label: 'Assistente de Base', value: 'chat', id: 'agent-chat' },
  { label: 'Smart Insight', value: 'insight', id: 'agent-insight' },
  { label: 'KPI\'s Rápidos', value: 'quickDash', id: 'agent-quickDash' },
  { label: 'Resumos', value: 'dashSummary', id: 'agent-dashSummary' },
];
